import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { ReactNode } from 'react';

export const ErrorBoundaryWithLocation = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  return <ErrorBoundary pathname={location.pathname}>{children}</ErrorBoundary>;
};
